import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {Message} from 'element-ui'
import {getUserID} from '@/utils/auth' // getToken from cookie
// import { setLocalStorage } from '@/utils/session' // getToken from cookie

NProgress.configure({showSpinner: false})// NProgress configuration

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.path === '/login_with_sso') {
    if (to.query.ticket) {
      store.dispatch('LoginWithSSO', to.query.ticket).then(res => { // 拉取用户信息
        next(to.query.redirect)
        //next(`/app`)
      }).catch((err) => {
        store.dispatch('FedLogOut').then(() => {
          // Message.error('SSO Verification failed, please login again')
          // Message.error(err || 'SSO Verification failed, please login again')
          next({ path: '/login'})
        })
      })
      NProgress.done()
    }
  }
  if (getUserID()) {
    if (to.path === '/login' || to.path === '/login_with_sso') {
      next({path: '/'})
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (!store.getters.username) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          next()
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            // Message.error('验证失败，请重新登录')
            next({ path: '/login'})
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js